function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var checkGlobal = require('./_checkGlobal');
/** Used to determine if values are of the language type `Object`. */


var objectTypes = {
  'function': true,
  'object': true
};
/** Detect free variable `exports`. */

var freeExports = objectTypes[typeof exports === "undefined" ? "undefined" : _typeof(exports)] && exports && !exports.nodeType ? exports : undefined;
/** Detect free variable `module`. */

var freeModule = objectTypes[typeof module === "undefined" ? "undefined" : _typeof(module)] && module && !module.nodeType ? module : undefined;
/** Detect free variable `global` from Node.js. */

var freeGlobal = checkGlobal(freeExports && freeModule && (typeof global === "undefined" ? "undefined" : _typeof(global)) == 'object' && global);
/** Detect free variable `self`. */

var freeSelf = checkGlobal(objectTypes[typeof self === "undefined" ? "undefined" : _typeof(self)] && self);
/** Detect free variable `window`. */

var freeWindow = checkGlobal(objectTypes[typeof window === "undefined" ? "undefined" : _typeof(window)] && window);
/** Detect `this` as the global object. */

var thisGlobal = checkGlobal(objectTypes[_typeof(this)] && this);
/**
 * Used as a reference to the global object.
 *
 * The `this` value is used if it's the global object to avoid Greasemonkey's
 * restricted `window` object, otherwise the `window` object is used.
 */

var root = freeGlobal || freeWindow !== (thisGlobal && thisGlobal.window) && freeWindow || freeSelf || thisGlobal || Function('return this')();
module.exports = root;